import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import axios from "axios";    

const Instagram = () => {
    const [images, setImages] = useState([]);

    const ACCESS_TOKEN = "IGAAqyHnz3x9tBZAGFFOGVDd0tfNW5nZA18wc3liTVVqUVVJSE9pa2ZA3eGlVYWItaU9EWUdVOWpyRUx6RkZA3LWlqaXM0c1JyUmwwNjZAtRkJGR24ybFFqZA2UzVDc2blZA6ZAjNpSlkzYVVWb2g3cDhRcXRyM19yT0tSQ2s0RFI2NDdPMAZDZD";

    useEffect(() => {
        axios
            .get("https://graph.instagram.com/me/media", {
            params: {
                fields: "id,media_type,media_url,thumbnail_url,permalink,caption",
                limit: 12,
                access_token: ACCESS_TOKEN,
            },
            })
            .then((res) => {
            setImages(res.data.data.slice(0, 10));
            })
            .catch((err) => {
                console.error("Instagram API error:", err.response?.data || err);
            });
        }, []);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024, // Adjust for tablet devices
                settings: { slidesToShow: 2, slidesToScroll: 1 },
            },
            {
                breakpoint: 600, // Adjust for mobile devices
                settings: { slidesToShow: 1, slidesToScroll: 1 },
            },
        ],
    };

    return (
        <div className="carousel-section">
            <div className="carousel-container">
                <div className="instafeed">
                    <div className="row">
                        <div class="carousel-bg mb-5">
                            <div class="main-title"><h2 class="carousel-heading">Instagram Feeds</h2></div>
                        </div>
                        <Slider {...settings}>
                            {images.map((item) => (
                                <a
                                    key={item.id}
                                    href={item.permalink}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {item.media_type === "VIDEO" ? (
                                    <video
                                        src={item.media_url}
                                        poster={item.thumbnail_url}
                                        controls
                                        style={{ width: "100%", borderRadius: "8px" }}
                                    />
                                    ) : (
                                    <img
                                        src={item.media_url}
                                        alt={item.caption || "Instagram post"}
                                        style={{ width: "100%", borderRadius: "8px" }}
                                    />
                                    )}
                                </a>
                                ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
        
    );
};

export default Instagram;
